import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaHome, FaQuestionCircle } from 'react-icons/fa';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import defaultLanguages from '../../../utils/helpers/defaultLanguage';
import HamburgerButton from '../HamburgerButton/HamburgerButton';
import { IconWrap } from '../IconWrap/IconWrap';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import Notifications from '../Notifications/Notifications';
import AccountMenu from './AccountMenu';
import MobileMenu from './MobileMenu';
import NavBrand from './NavBrand';
import NavMenu from './NavMenu';
import STATIC_NAV_LINKS from './staticNavLinks';
import './NavBar.css';

const QUICK_LINK_ICONS = {
  home: FaHome,
  howitworks: FaQuestionCircle
};

const NavBarPrivate = () => {
  const { tempedgeTranslator, locale: lang } = useTempEdgeTranslator();
  const { languages } = defaultLanguages();
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <header className="te-nav te-nav--solid" data-testid="navbar-private">
      <Container fluid>
        <Row className="te-nav-inner align-items-center justify-content-between">
          <Col xs="auto" className="te-nav-left">
            <HamburgerButton
              className="d-xl-none"
              toggleNav={() => setShowMobileMenu(true)}
              ariaLabel={tempedgeTranslator('com.tempedge.msg.nav.open_menu')}
            />
            <NavBrand to={`/dashboard/${lang}`} testId="navbar-private-brand" />
          </Col>

          <Col className="te-nav-center d-none d-xl-block">
            <NavMenu />
          </Col>

          <Col xs="auto" className="te-nav-right">
            <Notifications />

            <LanguageSelector languages={languages} variant="pills" />

            <div className="te-nav-private-actions d-none d-xl-flex">
              {STATIC_NAV_LINKS.map(({ id, labelKey, path }) => {
                const Icon = QUICK_LINK_ICONS[id];
                return (
                  <IconWrap
                    key={id}
                    path={`${path}/${lang}`}
                    title={tempedgeTranslator(labelKey)}
                    className="te-icon-btn"
                    testId={`navbar-quicklink-${id}`}
                  >
                    <Icon size={15} />
                  </IconWrap>
                );
              })}
              <AccountMenu />
            </div>
          </Col>
        </Row>
      </Container>

      <MobileMenu show={showMobileMenu} onClose={() => setShowMobileMenu(false)} />
    </header>
  );
};

export default NavBarPrivate;
